import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getDepartment = (departmentId: number | undefined): Promise<IGetDepartmentViaID> => {
  return axiosDefaultApi.get(`/api/Departments/GetDepartmentViaID/${departmentId}`);
};

type QueryFnType = typeof getDepartment;

type UseGetDepartmentOptions = {
  departmentId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetDepartment = ({ departmentId , config }: UseGetDepartmentOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getDepartment_${departmentId}`],
    queryFn: () => getDepartment(departmentId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Διεύθυνσης.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};